import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: {
    query: "",
    page: 1,
    status: "active",
  },
};

const settingMasterSlice = createSlice({
  name: "settingMaster",
  initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.search = {
        ...state.search,
        ...payload,
      };
    },
    clear: (state) => {
      state.search = initialState.search;
    },
  },
});

// selector
export const searchSelector = (state) => state.settingMaster.search;

// action
export const settingMasterAction = settingMasterSlice.actions;

// reducer
export default settingMasterSlice.reducer;
